import type { StaticLayerPayload } from "@config";
import { TimelineLibrary } from "@library-combos/Timeline";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: TimelineLibrary,
};

export const Timeline = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
